export enum EntityPresenterV2Mode {
  Live = 'live',
  Static = 'static',
  LazyLive = 'lazy-live'
}

export function isStaticMode(mode: EntityPresenterV2Mode): boolean {
  return mode === EntityPresenterV2Mode.Static;
}

export function isLiveMode(mode: EntityPresenterV2Mode): boolean {
  return mode === EntityPresenterV2Mode.Live;
}

export function isLazyLiveMode(mode: EntityPresenterV2Mode): boolean {
  return mode === EntityPresenterV2Mode.LazyLive;
}

export function subscribesToEventHub(mode: EntityPresenterV2Mode): boolean {
  return isLiveMode(mode) || isLazyLiveMode(mode);
}

export function isEntityPresenterV2QueryEnabled({
  mode,
  hasEffectiveId,
  isInViewport,
  lazyLiveUnlocked
}: {
  mode: EntityPresenterV2Mode;
  hasEffectiveId: boolean;
  isInViewport: boolean;
  lazyLiveUnlocked: boolean;
}): boolean {
  if (isStaticMode(mode)) {
    return false;
  }
  if (!hasEffectiveId) {
    return false;
  }
  if (!isInViewport) {
    return false;
  }
  if (isLazyLiveMode(mode) && !lazyLiveUnlocked) {
    return false;
  }
  return true;
}
